import { FC } from "react";
import styles from "./styles.scss";
import { NewsBoardItem } from "@/pages/home/components/news-board/news-board-item";
import { filter, map } from "lodash";
import { NewsBoardProps } from "@/pages/home/components/news-board/types";

export const NewsBoard: FC<NewsBoardProps> = ({ data }) => {
  const activeContent = filter(data, item => item.IsActive);

  return (
    <div className={styles.newsBoard}>
      {map(activeContent, (item, index) => (
        <NewsBoardItem {...item} key={`news-board-${index}`} />
      ))}
    </div>
  );
};
